// src/AdminHome.js
import React, { useState } from 'react';
import AdminVisitsToday from './AdminVisitsToday';
import AdminTeacherScheduledVisits from './AdminTeacherScheduledVisits';

const AdminHome = () => {
  const [activeTab, setActiveTab] = useState('today'); // 'today' | 'teacher_scheduled'

  return (
    <div className="p-0">
      {/* Tabs */}
      <div className="flex gap-2 border-b mb-3 px-1 pt-3">
        <button
          className={
            'px-1 py-1.5 text-sm rounded-t ' +
            (activeTab === 'today'
              ? 'bg-white border border-b-white border-gray-300 font-semibold'
              : 'bg-gray-100 text-gray-700 border border-transparent hover:bg-gray-200')
          }
          onClick={() => setActiveTab('today')}
        >
          Today&apos;s visits
        </button>

        <button
          className={
            'px-1 py-1.5 text-sm rounded-t ' +
            (activeTab === 'teacher_scheduled'
              ? 'bg-white border border-b-white border-gray-300 font-semibold'
              : 'bg-gray-100 text-gray-700 border border-transparent hover:bg-gray-200')
          }
          onClick={() => setActiveTab('teacher_scheduled')}
        >
          Teacher-scheduled visits
        </button>
      </div>

      {/* Content */}
      <div className="px-0 pb-4">
        {activeTab === 'today' && (
          <div className="p-0">
            <AdminVisitsToday />
          </div>
        )}

        {activeTab === 'teacher_scheduled' && (
          <div className="p-0">
            <AdminTeacherScheduledVisits />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminHome;
